import { PropsWithChildren } from 'react';

export const FooterMenuItem = ({ children }: PropsWithChildren<{}>) => {
  return <li className="text-sm leading-7 text-white">{children}</li>;
};
